<template>
    <b-container 
        class="content" 
        fluid 
        v-loading="!isLoaded" 
        :element-loading-text="$t('sourceLoading')"
    >
            <b-row style="border-bottom:1px solid #ddd;margin-bottom:2em;">
                    <h3>{{ $t('sourceManagement') }}</h3>
            </b-row>
            <b-row style="justify-content:space-between;">
                <b-col cols="8">
                    <ul class="nav nav-tabs">
                        <li v-for="(tab,tabKey) in tabs" class="nav-item p-2" style="cursor: pointer;" :style="tab.isActive ? tab.style.border : ''" :key="tabKey">
                            <div @click="activate(tabKey)" :class="{'nav-link': true, 'active': tab.isActive}" :style="tab.isActive ? tab.style.tab : ''">{{ tab.name }}  <b-badge pill :style="tab.isActive ? tab.style.badge : ''">{{ tab.tableInfo.items.length }}</b-badge></div>
                        </li>
                    </ul>
                </b-col>
                <b-col cols="4" style="float:right;text-align:right;">
                    <template v-if="tabs.activeSources.isActive">
                        <b-button key="addSource" style="background-color:#41B884;" lg="2" class="pb-2" @click="showCreateSourceModal($event.target)">{{ $t('addSource') }}</b-button>
                    </template>
                    <template v-else>
                    </template>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mt-3" md="2">
                    <b-form-input
                    v-model="searchInput"
                    style="padding: 5px 10px;"
                    :placeholder="$t('searchSource')"
                    @input="filterData"/>
                </b-col>
                
            </b-row>
            
            <vue-table
                tableName="active sources"
                v-if="this.tabs.activeSources.isActive"
                :initialData="itemsForList(this.tabs.activeSources.tableInfo)"
                :isEditable="true"
                :isScrollable="false"
                class="mt-3"
                @openEditModal="showEditSourceModal"
                @per-page="setPerPage"
            />
            <vue-table
                v-else
                tableName="inactive sources"
                :initialData="itemsForList(this.tabs.inactiveSources.tableInfo)"
                :isEditable="true"
                :isScrollable="false"
                class="mt-3"
                @openEditModal="showEditSourceModal"
                @per-page="setPerPage"
            />
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="itemList"
                align="right"
            ></b-pagination>
            

    </b-container>
</template>

<script>
import VueTable from '../../components/Table';
import SiteMultiSelectTree from '../../components/SiteMultiSelectTree.vue';
import _ from 'lodash';
import uuid from 'uuid/v4';

export default {
    components: {VueTable, SiteMultiSelectTree},
    name: 'Sources',
    data() {
        return {
            tabs:{
                activeSources:{
                    isActive:true,
                    tableInfo:{fields:[],items:[]},
                    name: this.$t('activeSources'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    }
                },
                inactiveSources:{
                    isActive:false,
                    tableInfo:{fields:[],items:[]},
                    name: this.$t('inactiveSources'),
                    style:{
                        border:{'border-bottom':'3px solid #022B49'},
                        tab:{'color':'#022B49'},
                        badge:{'background-color':'#022B49'}
                    }
                }
            },
            selectedItem: {
                isActive: true
            },
            error:{},
            activeTab:'activeSources',
            currentPage: 1,
            perPage: 3,
            // perPage: 7,
            totalRows: 0,
            isLoaded: false,
            inProgress: false,
            searchInput: '',
            editedItem: {
                emissionFactors:{}
            },
            modalType: null,
            showModal: false,
            scopeGroups: null,
            sourceTypes: null,
            sourceTypeGroups: null,
            allSites: [],
            emissionTypes: null,
            temps: {
                name: null,
                startDate: null,
                emissionFactor: null,
                source: null
            },
            unitList: [],
            unitMap: {},
            unitTypeMap:{id:{},name:{}},
            emisssionCustomInsertMode: false,
            emissionCustomItem:{},
            newEmissionModel: {},
            dataUnits: null,
        };
    },
    methods: {
        setPerPage(perPage) {
            this.perPage = perPage;
        },
        forceUpdate() {
            this.$forceUpdate();
        },
        activate(key){
            this.activeTab = key;
            _.each(this.tabs, (tab,tabKey)=> {
                this.currentPage = 1;
                tab.isActive = key==tabKey;
            });
        },
        filterData(){
            this.currentPage = 1;
            this.forceUpdate();
        },
        itemsForList(data) {
            let searchedDataItems = this.searchData(data.items);
            this.totalRows = searchedDataItems.length;

            return {
                fields: data.fields,
                items: searchedDataItems.slice(
                    (this.currentPage - 1) * this.perPage,
                    this.currentPage * this.perPage,
                )
            };
        },
        searchData(dataItems){
            if (this.searchInput.length < 1) {
                return dataItems
            } else {
                return _.filter(dataItems, o => {
                    return (
                        _.includes(this.toLocaleLowerCase(this.$t(o.cols.name.value)), this.toLocaleLowerCase(this.searchInput))
                        || _.includes(this.toLocaleLowerCase(this.$t(o.cols.detail.value)), this.toLocaleLowerCase(this.searchInput))
                        || _.includes(this.toLocaleLowerCase(this.$t(o.cols.type.value[0]) + ' ' + this.$t(o.cols.type.value[1])), this.toLocaleLowerCase(this.searchInput))
                        || _.includes(this.toLocaleLowerCase(_.join(o.cols.locations.value, ' ')), this.toLocaleLowerCase(this.searchInput))
                    )
                });
            }
        },
        isEmissionFactorInputDisabled(isCO2eInput){
            if(isCO2eInput){
                if(_.includes(Object.keys(this.editedItem.emissionFactors), 'CO2e')){
                    if(this.editedItem.emissionFactors['CO2e'] != ''){
                        _.each(Object.keys(this.editedItem.emissionFactors), key => {
                            if(key != 'CO2e'){
                                this.editedItem.emissionFactors[key] = '';
                            }
                        })
                        return true;
                    }
                }
            } else {
                let intersection = _.intersection(Object.keys(this.editedItem.emissionFactors), ['CO2', 'N2O', 'CH4']);
                if(_.size(intersection) > 0) {
                    let nonEmptyIntersections = _.filter(intersection, o => {
                        return this.editedItem.emissionFactors[o] == '';
                    })
                    if(!(_.size(nonEmptyIntersections) > 0)){
                        _.each(Object.keys(this.editedItem.emissionFactors), key => {
                            if(key == 'CO2e'){
                                this.editedItem.emissionFactors[key] = '';
                            }
                        })
                        return true;
                    };
                }
            }
            return false;
        },
        deleteSource(id, isActive) {
            if(isActive) {
                this.tabs.activeSources.tableInfo.items = _.filter(this.tabs.activeSources.tableInfo.items, o=> o.id != id);
            }
            else {
                this.tabs.inactiveSources.tableInfo.items = _.filter(this.tabs.inactiveSources.tableInfo.items, o=> o.id != id);
            }
        },
        setSelectedSource(itemData) {
            let isActive = (itemData.name == 'active sources' || itemData.name == 'active_data_summary');

            if(isActive){
                this.selectedItem = _.find(this.tabs.activeSources.tableInfo.items, o=> o.id == itemData.id);
            }
            else{
                this.selectedItem = _.find(this.tabs.inactiveSources.tableInfo.items, o=> o.id == itemData.id);
            }

            this.selectedItem.isActive = isActive;
        },
        showCreateSourceModal(target) {
            this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'createSource',
                    payload: {
                        page: 'sourceManagement',
                        title: "createSource",
                        selectedSource: {},
                    }   
                });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createSource', target);
                this.$eventHub.$once(this.$store.state.modal.eventId, result => {
                    if (result.emitter === 'insert') {
                        this.init();
                    }
                });
            });
        },
        showEditSourceModal(itemData, event) {

            this.setSelectedSource(itemData);

            this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'updateSource',
                    payload: {
                        page: 'sourceManagement',
                        title: "updateSource",
                        selectedSource: {},
                        selectedItem: this.selectedItem,

                    }   
                });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createSource', event.target);
                this.$eventHub.$once(this.$store.state.modal.eventId, result => {
                    if (result.emitter === 'update') {
                        this.init();
                    } else if(result.emitter == 'delete') {
                        this.deleteSource(result.data.id, result.data.isActive);
                    }
                });
            });
        },
        init(){
            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/getSourceManagement').then(({data}) => {
                this.tabs.activeSources.tableInfo = {
                    fields: data.active.fields,
                    items: _.sortBy(data.active.items, o=>{
                        return _.toLower(this.$t(_.get(_.get(_.get(o, 'cols'), 'name'), 'value')))
                    })
                };
                this.tabs.inactiveSources.tableInfo = {
                    fields: data.inactive.fields,
                    items: _.sortBy(data.inactive.items, o=>{
                        return _.toLower(this.$t(_.get(_.get(_.get(o, 'cols'), 'name'), 'value')))
                    })
                };

                this.isLoaded = true;
                this.$Progress.finish();

                this.totalRows = this.tabs[this.activeTab].tableInfo.items.length;
            });
        },

    },
    watch: {
        emisssionCustomInsertMode() {
            this.forceUpdate();
        }
    },
    created(){
        this.init();
    }
};
</script>

<style lang="scss" scoped>
#tabs .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    border: none;
    background-color: transparent;
    border-color: transparent transparent #f3f3f3;
    font-size: 16px;
    font-weight: bold;
}
.nav-tabs{
    color: #A7A7A7;
    border-bottom: none !important;
}
.nav-tabs:hover, .nav-link:hover {
    border: none;
}
.circle-icon {
    background: #777879;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    height: auto;
    width: auto;
    padding: 10px;
}


/deep/ .page-item.active .page-link {
    background-color: #41B884;
    border-color: #41B884;
}
/deep/ .page-link {
    color: #41B884;
    border-color: #41B884;
}
/deep/ .page-item.disabled .page-link {
    color: #41B884;
    border-color: #41B884;
}

@media (min-width: 576px) {
    /deep/ .modal-xl {
        max-width: 1200px;
    }
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
   { 
        "tr": {
            "sourceLoading": "Kaynak Listesi Yükleniyor...",
            "sourceManagement": "Kaynak Yönetimi",
            "addSource": "Kaynak Ekle",
            "searchSource": "Kaynak Arama",
            "activeSources": "Aktif Kaynaklar",
            "inactiveSources": "Pasif Kaynaklar"
        },
        "en": {
            "sourceLoading": "Loading Source List...",
            "sourceManagement": "Source Management",
            "addSource": "Add Source",
            "searchSource": "Search Source",
            "activeSources": "Active Sources",
            "inactiveSources": "Inactive Sources"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/Sources.vue